import React from "react";
import {
  TextField,
  CardMedia,
  Card,
  Typography,
  Button,
  Slider,
  Divider,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Tabs,
  Tab,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  OutlinedInput,
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Container from "@material-ui/core/Container";
import Alert from "@material-ui/lab/Alert";
import CustomAlert from "../../components/CustomAlert/CustomAlert";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { useTranslation } from "react-i18next";
import {
  Delete,
  ExpandMore,
  Map,
  PhoneAndroidOutlined,
  TabletAndroid,
} from "@material-ui/icons";
import { Link } from "react-router-dom";

import ImageUtils from "../../../utils/imageUtils";
import DraggableList from "../../components/draggableList";
import ListItemLink from "../../components/listItemLink";
import DialogWarning from "../../components/dialogWarning";
import LoadingView from "../../components/loadingView";
import TourHierarchyComponent from "../../components/TourHierarchy/TourHierarchyComponent";
import { GameMode } from "../../../constants/TourConstants";
import BreadcrumbTour from "../../components/breadcrumTour";
import SouthWestIcon from "../../../utils/southWestIcon";
import SelectLocationDialog from "../../components/selectOnMapDialog";
import UnsavedChangesIndicator from "../../components/unsevedChangesIndicator";
import { Prompt } from "react-router-dom/cjs/react-router-dom.min";
import InfoPopover from "../../../utils/informationButton";
import NoSubscriptionBanner from "../home/components/noSubscriptionBanner";
import DisableToursPopover from "../../../utils/disableToursPopover";
import TutorialBubble from "../../../utils/tutorialBubble";
import ImagePreview from "../../components/imagePreview/ImagePreview";
import SkeletonComponent from "../../components/Skeleton/SkeletonComponent";
import MDEditor from "@uiw/react-md-editor";
import remarkBreaks from "remark-breaks";

const TourView = (props) => {
  const zonesItems = props.getZonesItems();
  const { t } = useTranslation();

  const toSyntheticEvent = (value) => ({
    preventDefault: () => { },
    target: { value },
  });

  function ValueLabelComponent(props) {
    const { children, open, value } = props;

    return (
      <Tooltip open={open} enterTouchDelay={0} placement="bottom" title={value}>
        {children}
      </Tooltip>
    );
  }

  return (
    <>
      <TourHierarchyComponent
        tourId={props.state.formDatas ? props.state.formDatas.tourId : null}
        tourTitle={props.state.formDatas ? props.state.formDatas.title : ""}
        isConfigActive={true}
        role={props.state.role}
        tourDisabled={props.state.formDatas ? props.state.formDatas.disabled : false}
      />
      <Box className={`${props.classes.root} ${props.classes.mainContent}`}>
        <NoSubscriptionBanner
          role={props.state.role}
          redirectToSelectedPack={null}
          classes={props.classes}
        />
        <DisableToursPopover
          userOpenedPopover={props.state.isDisableToursOpened}
        />
        <Container className={props.classes.formContainer} maxWidth={false}>
          <UnsavedChangesIndicator
            show={props.state.unsavedChanges}
            style={{
              position: "fixed",
              top: "80px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 99999,
            }}
          />
          <Prompt
            when={props.state.unsavedChanges}
            message={t("newTour.unsaved_changes")}
          />
          <BreadcrumbTour
            tourId={props.state.formDatas ? props.state.formDatas.tourId : null}
            zoneId={props.zoneId}
            enigmaId={props.enigmaId}
          />
          <br />

          {props.state.isAdmin &&
            props.state.formDatas.userAskedMonetization && (
              <Grid item xs={12}>
                <Box className={props.classes.stripeConnectBox} p={2} mb={2}>
                  <Typography variant="h6" gutterBottom>
                    {t("newTour.stripe_connect_settings")}
                  </Typography>
                  {!props.state.adminFormDatas
                    .accountStripeConnectAuthorized && (
                      <Typography variant="body2" color="error" gutterBottom>
                        La demande de création de compte Stripe Connect n'est pas
                        encore validée. Veuillez la valider pour que la
                        monétisation de ce parcours soit active.
                      </Typography>
                    )}
                  <form
                    className={props.classes.form}
                    autoComplete="off"
                    onSubmit={props.handleStripeConnectSubmit}
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="userCanMonetizedTour"
                              checked={
                                props.state.adminFormDatas.userCanMonetizedTour
                              }
                              onChange={props.updateUserCanMonetizedTour}
                              color="primary"
                              disabled={
                                !props.state.adminFormDatas
                                  .accountStripeConnectAuthorized
                              }
                            />
                          }
                          label={t("newTour.user_can_monetized_tour")}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          label={t("newTour.stripe_connect_commission_percent")}
                          type="number"
                          value={
                            props.state.adminFormDatas
                              .stripeConnectCommissionPercent
                          }
                          onChange={props.updateStripeConnectCommissionPercent}
                          InputProps={{
                            inputProps: { min: 0, max: 100, step: 0.01 },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          label={t("newTour.stripe_connect_commission_fix")}
                          type="number"
                          value={
                            props.state.adminFormDatas.StripeConnectComissionFix
                          }
                          onChange={props.updateStripeConnectComissionFix}
                          InputProps={{
                            inputProps: { min: 0, step: 0.01 },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          style={{
                            marginTop: "16px",
                            textTransform: "none",
                          }}
                        >
                          {t("newTour.save_stripe_connect_settings")}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Box>
              </Grid>
            )}

          <form
            className={props.classes.form}
            autoComplete="off"
            onSubmit={props.submitForm}
          >
            <Grid container spacing={3}>
              {props.state.isAdmin && (
                <Grid item xs={12}>
                  <FormControlLabel
                    style={{ marginLeft: 6 }}
                    control={
                      <Checkbox
                        name="mustAddAnalyticBeforeLaunch"
                        checked={
                          props.state.formDatas.mustAddAnalyticBeforeLaunch
                        }
                        onChange={props.updateMustAddAnalyticBeforeLaunch}
                        color="primary"
                      />
                    }
                    label={t("newTour.blocking_stats_submission")}
                  />
                  <FormControlLabel
                    style={{ marginLeft: 6 }}
                    control={
                      <Checkbox
                        name="needDownloadMapTiles"
                        checked={props.state.formDatas.needDownloadMapTiles}
                        onChange={props.updateNeedDownloadMapTiles}
                        color="primary"
                      />
                    }
                    label={t("newTour.download_map_to_device")}
                  />
                  <FormControlLabel
                    style={{ marginLeft: 6 }}
                    control={
                      <Checkbox
                        name="showRateThisApp"
                        checked={props.state.formDatas.showRateThisApp}
                        onChange={props.updateShowRateThisApp}
                        color="primary"
                      />
                    }
                    label="Afficher le popup de notation de l'application"
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                {!props.state.tourLoaded ? (
                  <SkeletonComponent type="blocks"></SkeletonComponent>
                ) : (
                  <>
                    <Box className={props.classes.pannel}>
                      <Typography
                        variant="h6"
                        gutterBottom
                        style={{
                          fontWeight: 600,
                          marginBottom: 16,
                          color: "#1F2937",
                        }}
                      >
                        {t("newTour.tour_configuration")}
                      </Typography>

                      <Grid container spacing={4}>
                        <Grid item xs={12} md={4}>
                          <FormControl
                            fullWidth
                            variant="outlined"
                            className={props.classes.select}
                          >
                            <InputLabel>{t("newTour.game_type")}</InputLabel>
                            <Select
                              value={props.state.formDatas.gameMode}
                              onChange={props.handleGameModeChange}
                              label={t("newTour.game_type")}
                            >
                              <MenuItem value={GameMode.MAP_AND_QRCODE}>
                                {t("newTour.map_and_qr_codes")}
                              </MenuItem>
                              <MenuItem value={GameMode.ONLY_QRCODE}>
                                {t("newTour.only_qr_codes")}
                              </MenuItem>
                              <MenuItem value={GameMode.AUTOMATIC_LAUNCH}>
                                {t("newTour.automatic_launch")}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={1}>
                          {props.state.formDatas.gameMode ==
                            GameMode.ONLY_QRCODE ? (
                            <>
                              {" "}
                              <InfoPopover
                                title={t("newTour.only_qr_codes")}
                                text={t("newTour.qr_code_mode_info")}
                              ></InfoPopover>
                            </>
                          ) : props.state.formDatas.gameMode ==
                            GameMode.MAP_AND_QRCODE ? (
                            <>
                              <InfoPopover
                                title={t("newTour.map_and_qr_codes")}
                                text={t("newTour.map_qr_code_mode_info")}
                              ></InfoPopover>
                            </>
                          ) : props.state.formDatas.gameMode ==
                            GameMode.AUTOMATIC_LAUNCH ? (
                            <>
                              <InfoPopover
                                title={t("newTour.automatic_launch")}
                                text={t("newTour.automatic_mode_info")}
                              ></InfoPopover>
                            </>
                          ) : (
                            <></>
                          )}
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            label={t("newTour.game_time")}
                            type="number"
                            value={props.state.formDatas.timer}
                            onChange={props.updateTimer}
                            className={props.classes.textField}
                            InputProps={{
                              inputProps: { min: 0, max: 600 },
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            label={t("newTour.game_title")}
                            value={props.state.formDatas.title}
                            onChange={props.updateTitle}
                            className={props.classes.textField}
                            required
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Typography
                            style={{
                              fontWeight: 500,
                              color: "#1F2937",
                              marginBottom: 8,
                            }}
                          >
                            {t("newTour.game_description")}
                          </Typography>

                          <Box
                            className={props.classes.markdownEditorContainer}
                            data-color-mode="light"
                            style={{
                              "--md-edit-label": `"${t("markdown_editor.edit_label")}"`,
                              "--md-preview-label": `"${t("markdown_editor.preview_label")}"`,
                            }}
                          >
                            <MDEditor
                              value={props.state.formDatas.subtitle || ""}
                              onChange={(value) => {
                                props.updateSubtitle(toSyntheticEvent(value || ""));
                              }}
                              preview="live"
                              highlightEnable={false}
                              height={200}
                              visibleDragbar={false}
                              textareaProps={{ maxLength: 2000 }}
                              previewOptions={{
                                remarkPlugins: [remarkBreaks],
                              }}
                              commandsFilter={(command, isExtra) => {
                                if (command?.name === "fullscreen") return false;
                                return command;
                              }}
                            />
                          </Box>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            flexWrap="wrap"
                          >
                            <Typography
                              className={props.classes.markdownEditorHint}
                            >
                              {t("markdown_editor.hint")}
                            </Typography>
                            <Typography
                              style={{
                                fontSize: "12px",
                                color: "#9CA3AF",
                                textAlign: "right",
                                marginTop: "4px",
                                marginRight: "12px",
                              }}
                            >
                              {(props.state.formDatas.subtitle || "").length}/2000
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={props.state.formDatas.cluesFree}
                                onChange={props.updateCluesFree}
                                className={props.classes.checkbox}
                              />
                            }
                            label={t("newTour.free_hints")}
                          />
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <InfoPopover
                            title={t("newTour.clues_free")}
                            text={t("newTour.free_clues_info")}
                          ></InfoPopover>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={props.state.formDatas.askUserEmail}
                                onChange={props.updateAskUserEmail}
                                className={props.classes.checkbox}
                              />
                            }
                            label={t("newTour.collect_player_emails")}
                          />
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <InfoPopover
                            title={t("newTour.collect_player_emails")}
                            text={t("newTour.collect_player_emails_info")}
                          ></InfoPopover>
                        </Grid>
                      </Grid>
                    </Box>

                    <Grid container spacing={3} style={{ marginTop: 24 }}>
                      <Grid
                        item
                        xs={12}
                        sm={
                          props.state.formDatas.gameMode ==
                            GameMode.MAP_AND_QRCODE
                            ? 6
                            : 12
                        }
                      >
                        <Box
                          style={{
                            backgroundColor: "white",
                            borderRadius: "24px",
                            padding: "32px 40px",
                            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                            border: "1px solid #E0E0E0",
                            height: "100%",
                          }}
                        >
                          <Typography
                            variant="h6"
                            gutterBottom
                            style={{
                              fontWeight: 600,
                              marginBottom: 24,
                              color: "#1F2937",
                              fontSize: "1.25rem",
                            }}
                          >
                            {t("newTour.media")}
                          </Typography>

                          <Box
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 20,
                            }}
                          >
                            {/* Image de présentation */}
                            <Grid
                              container
                              justifyContent="space-between"
                              style={{
                                // display: "flex",
                                alignItems: "center",
                                backgroundColor: "#F8F9FA",
                                borderRadius: "12px",
                                padding: "16px 20px",
                                // gap: 16,
                                transition: "all 0.2s ease-in-out",
                                "&:hover": {
                                  backgroundColor: "#F1F5F9",
                                },
                              }}
                            >
                              <Grid item md={12} lg={6}>
                                <Box style={{ flex: 1 }}>
                                  <Typography
                                    style={{
                                      fontWeight: 500,
                                      color: "#1F2937",
                                      marginBottom: 4,
                                    }}
                                  >
                                    {t("newTour.presentation_image")}
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid
                                item
                                md={12}
                                lg={6}
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Box
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                  }}
                                >
                                  <Button
                                    className={props.classes.iconUploadButton}
                                    component="label"
                                    style={{
                                      minWidth: "auto",
                                      padding: "10px",
                                      backgroundColor: "#3B82F6",
                                      borderRadius: "8px",
                                      transition: "all 0.2s ease-in-out",
                                      "&:hover": {
                                        backgroundColor: "#2563EB",
                                        transform: "translateY(-1px)",
                                      },
                                    }}
                                  >
                                    <input
                                      type="file"
                                      hidden
                                      onChange={props.backgroundImageSelected}
                                      accept=".png,.jpg,.jpeg"
                                    />
                                    <CloudUploadIcon
                                      style={{ color: "white", fontSize: 20 }}
                                    />
                                  </Button>
                                  {(props.state.formDatas.backgroundImageFile ||
                                    props.state.formDatas
                                      .backgroundImageUrl) && (
                                      <ImagePreview
                                        imageFile={
                                          props.state.formDatas
                                            .backgroundImageFile
                                        }
                                        imageUrl={
                                          props.state.formDatas.backgroundImageUrl
                                        }
                                        phoneWidth={411}
                                        phoneHeight={794}
                                        tabletWidth={1024}
                                        tabletHeight={1310}
                                        titleOneImageInfo={t(
                                          "newTour.image_display_before_game_phone"
                                        )}
                                        titleTwoImageInfo={t(
                                          "newTour.image_display_before_game_tablet"
                                        )}
                                        twoPreviewsPerTab={true}
                                      />
                                    )}
                                </Box>
                              </Grid>
                            </Grid>

                            {/* Icône du point de retour */}
                            {props.state.formDatas.gameMode ==
                              GameMode.MAP_AND_QRCODE && (
                                <Grid
                                  container
                                  justifyContent="space-between"
                                  style={{
                                    // display: "flex",
                                    alignItems: "center",
                                    backgroundColor: "#F8F9FA",
                                    borderRadius: "12px",
                                    padding: "16px 20px",
                                    // gap: 16,
                                    transition: "all 0.2s ease-in-out",
                                    "&:hover": {
                                      backgroundColor: "#F1F5F9",
                                    },
                                  }}
                                >
                                  <Grid item md={12} lg={6}>
                                    <Box style={{ flex: 1 }}>
                                      <Typography
                                        style={{
                                          fontWeight: 500,
                                          color: "#1F2937",
                                          marginBottom: 4,
                                        }}
                                      >
                                        {t("newTour.return_point_icon")}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid
                                    item
                                    md={12}
                                    lg={6}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Box
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <Button
                                        className={props.classes.iconUploadButton}
                                        component="label"
                                        style={{
                                          minWidth: "auto",
                                          padding: "10px",
                                          backgroundColor: "#3B82F6",
                                          borderRadius: "8px",
                                          transition: "all 0.2s ease-in-out",
                                          marginRight: 8,
                                          "&:hover": {
                                            backgroundColor: "#2563EB",
                                            transform: "translateY(-1px)",
                                          },
                                        }}
                                      >
                                        <input
                                          type="file"
                                          hidden
                                          onChange={props.annotationImageSelected}
                                          accept=".png,.jpg,.jpeg"
                                        />
                                        <CloudUploadIcon
                                          style={{ color: "white", fontSize: 20 }}
                                        />
                                      </Button>
                                    </Box>
                                    {(props.state.formDatas.annotationImageFile ||
                                      props.state.formDatas
                                        .annotationImageUrl) && (
                                        <ImagePreview
                                          imageFile={
                                            props.state.formDatas
                                              .annotationImageFile
                                          }
                                          imageUrl={
                                            props.state.formDatas.annotationImageUrl
                                          }
                                          phoneWidth={400}
                                          phoneHeight={400}
                                          tabletWidth={900}
                                          tabletHeight={900}
                                        />
                                      )}
                                    {(props.state.formDatas.annotationImageFile ||
                                      props.state.formDatas
                                        .annotationImageUrl) && (
                                        <IconButton
                                          className={props.classes.deleteIconButton}
                                          onClick={props.deleteAnnotationImage}
                                          style={{
                                            padding: "10px",
                                            color: "#EF4444",
                                            marginLeft: 8,
                                            backgroundColor: "#FEE2E2",
                                            "&:hover": {
                                              backgroundColor: "#FECACA",
                                            },
                                          }}
                                        >
                                          <Delete style={{ fontSize: 20 }} />
                                        </IconButton>
                                      )}
                                  </Grid>
                                </Grid>
                              )}

                            {/* Section Optionnel */}
                            <Typography
                              variant="subtitle1"
                              style={{
                                fontWeight: 600,
                                marginTop: 8,
                                color: "#757373",
                                fontStyle: "italic",
                                fontSize: "1rem",
                              }}
                            >
                              {t("newTour.optional")}
                            </Typography>

                            {/* Bande sonore */}
                            <Box
                              style={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#F8F9FA",
                                borderRadius: "12px",
                                padding: "16px 20px",
                                gap: 16,
                                transition: "all 0.2s ease-in-out",
                                "&:hover": {
                                  backgroundColor: "#F1F5F9",
                                },
                              }}
                            >
                              <Grid
                                container
                                justifyContent="space-between"
                                style={{
                                  // display: "flex",
                                  alignItems: "center",
                                  backgroundColor: "#F8F9FA",
                                  borderRadius: "12px",
                                  padding: "0px 20px",
                                  // gap: 16,
                                  transition: "all 0.2s ease-in-out",
                                  "&:hover": {
                                    backgroundColor: "#F1F5F9",
                                  },
                                }}
                              >
                                <Grid item md={12} lg={6}>
                                  <Box style={{ flex: 1 }}>
                                    <Typography
                                      style={{
                                        fontWeight: 500,
                                        color: "#1F2937",
                                        marginBottom: 4,
                                      }}
                                    >
                                      {t("newTour.sound_track")}
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  md={12}
                                  lg={6}
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Box
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 8,
                                    }}
                                  >
                                    <Button
                                      className={props.classes.iconUploadButton}
                                      component="label"
                                      style={{
                                        minWidth: "auto",
                                        padding: "10px",
                                        backgroundColor: "#3B82F6",
                                        borderRadius: "8px",
                                        transition: "all 0.2s ease-in-out",
                                        "&:hover": {
                                          backgroundColor: "#2563EB",
                                          transform: "translateY(-1px)",
                                        },
                                      }}
                                    >
                                      <input
                                        type="file"
                                        hidden
                                        onChange={props.backgroundMusicSelected}
                                        accept=".mp3,.wav"
                                      />
                                      <CloudUploadIcon
                                        style={{ color: "white", fontSize: 20 }}
                                      />
                                    </Button>

                                    {(props.state.formDatas.musicFile ||
                                      props.state.formDatas.musicFileName) && (
                                        <IconButton
                                          className={props.classes.deleteIconButton}
                                          onClick={props.deleteMusic}
                                          style={{
                                            padding: "10px",
                                            color: "#EF4444",
                                            backgroundColor: "#FEE2E2",
                                            "&:hover": {
                                              backgroundColor: "#FECACA",
                                            },
                                          }}
                                        >
                                          <Delete style={{ fontSize: 20 }} />
                                        </IconButton>
                                      )}
                                  </Box>
                                </Grid>
                                <Box
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  {(props.state.formDatas.musicFileName ||
                                    props.state.formDatas.musicFile) && (
                                      <Typography
                                        className={
                                          props.classes.imageDimensionsText
                                        }
                                        id="discrete-slider"
                                        gutterBottom
                                        style={{ textAlign: "center" }}
                                      >
                                        {props.state.formDatas.musicFile?.name !=
                                          null
                                          ? props.state.formDatas.musicFile?.name
                                          : props.state.formDatas.musicFileName}
                                      </Typography>
                                    )}
                                </Box>
                              </Grid>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>

                      {props.state.formDatas.gameMode ==
                        GameMode.MAP_AND_QRCODE && (
                          <Grid item xs={12} sm={6}>
                            <Box
                              style={{
                                backgroundColor: "white",
                                borderRadius: "24px",
                                padding: "32px 40px",
                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                                border: "1px solid #E0E0E0",
                                height: "100%",
                              }}
                            >
                              <Typography
                                variant="h6"
                                gutterBottom
                                style={{
                                  fontWeight: 600,
                                  marginBottom: 24,
                                  color: "#1F2937",
                                  fontSize: "1.25rem",
                                }}
                              >
                                {t("newTour.localization")}
                              </Typography>

                              <Box
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 24,
                                }}
                              >
                                {/* Limite Nord-Est */}
                                <Box>
                                  <Typography
                                    style={{
                                      fontWeight: 500,
                                      color: "#1F2937",
                                      marginBottom: 12,
                                      fontSize: "1rem",
                                    }}
                                  >
                                    {t("newTour.map_northeast_limit")}
                                  </Typography>
                                  <Button
                                    className={props.classes.softButton}
                                    fullWidth
                                    variant="outlined"
                                    onClick={() => props.openMapDialog("NE")}
                                    style={{
                                      backgroundColor: "#F8F9FA",
                                      borderRadius: "12px",
                                      border: "1px solid #E0E0E0",
                                      color: "#1F2937",
                                      padding: "12px 24px",
                                      marginBottom: 16,
                                      textTransform: "none",
                                      fontWeight: 500,
                                      transition: "all 0.2s ease-in-out",
                                      "&:hover": {
                                        backgroundColor: "#F1F5F9",
                                        borderColor: "#D1D5DB",
                                      },
                                    }}
                                  >
                                    {t("newTour.select_pos")}
                                  </Button>

                                  <Box className={props.classes.coordsRow} style={{ display: "flex", gap: 12 }}>
                                    <TextField
                                      fullWidth
                                      label={t("newTour.latitude")}
                                      variant="outlined"
                                      value={
                                        props.state.formDatas.cameraBoundsNE
                                          .latitude !== 0
                                          ? props.state.formDatas.cameraBoundsNE
                                            .latitude
                                          : ""
                                      }
                                      onChange={
                                        props.updateCameraBoundsNELatitude
                                      }
                                      className={props.classes.textField}
                                      style={{
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "12px",
                                          backgroundColor: "#F8F9FA",
                                          "&:hover": {
                                            backgroundColor: "#F1F5F9",
                                          },
                                        },
                                      }}
                                    />
                                    <TextField
                                      fullWidth
                                      label={t("newTour.longitude")}
                                      variant="outlined"
                                      value={
                                        props.state.formDatas.cameraBoundsNE
                                          .longitude !== 0
                                          ? props.state.formDatas.cameraBoundsNE
                                            .longitude
                                          : ""
                                      }
                                      onChange={
                                        props.updateCameraBoundsNELongitude
                                      }
                                      className={props.classes.textField}
                                      style={{
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "12px",
                                          backgroundColor: "#F8F9FA",
                                          "&:hover": {
                                            backgroundColor: "#F1F5F9",
                                          },
                                        },
                                      }}
                                    />
                                  </Box>
                                </Box>

                                {/* Limite Sud-Ouest */}
                                <Box>
                                  <Typography
                                    style={{
                                      fontWeight: 500,
                                      color: "#1F2937",
                                      marginBottom: 12,
                                      fontSize: "1rem",
                                    }}
                                  >
                                    {t("newTour.map_southwest_limit")}
                                  </Typography>
                                  <Button
                                    className={props.classes.softButton}
                                    fullWidth
                                    variant="outlined"
                                    onClick={() => props.openMapDialog("SW")}
                                    style={{
                                      backgroundColor: "#F8F9FA",
                                      borderRadius: "12px",
                                      border: "1px solid #E0E0E0",
                                      color: "#1F2937",
                                      padding: "12px 24px",
                                      marginBottom: 16,
                                      textTransform: "none",
                                      fontWeight: 500,
                                      transition: "all 0.2s ease-in-out",
                                      "&:hover": {
                                        backgroundColor: "#F1F5F9",
                                        borderColor: "#D1D5DB",
                                      },
                                    }}
                                  >
                                    {t("newTour.select_pos")}
                                  </Button>

                                  <Box className={props.classes.coordsRow} style={{ display: "flex", gap: 12 }}>
                                    <TextField
                                      fullWidth
                                      label={t("newTour.latitude")}
                                      variant="outlined"
                                      value={
                                        props.state.formDatas.cameraBoundsSW
                                          .latitude !== 0
                                          ? props.state.formDatas.cameraBoundsSW
                                            .latitude
                                          : ""
                                      }
                                      onChange={
                                        props.updateCameraBoundsSWLatitude
                                      }
                                      className={props.classes.textField}
                                      style={{
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "12px",
                                          backgroundColor: "#F8F9FA",
                                          "&:hover": {
                                            backgroundColor: "#F1F5F9",
                                          },
                                        },
                                      }}
                                    />
                                    <TextField
                                      fullWidth
                                      label={t("newTour.longitude")}
                                      variant="outlined"
                                      value={
                                        props.state.formDatas.cameraBoundsSW
                                          .longitude !== 0
                                          ? props.state.formDatas.cameraBoundsSW
                                            .longitude
                                          : ""
                                      }
                                      onChange={
                                        props.updateCameraBoundsSWLongitude
                                      }
                                      className={props.classes.textField}
                                      style={{
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "12px",
                                          backgroundColor: "#F8F9FA",
                                          "&:hover": {
                                            backgroundColor: "#F1F5F9",
                                          },
                                        },
                                      }}
                                    />
                                  </Box>
                                </Box>

                                {/* Point de retour */}
                                <Box>
                                  <Typography
                                    style={{
                                      fontWeight: 500,
                                      color: "#1F2937",
                                      marginBottom: 12,
                                      fontSize: "1rem",
                                    }}
                                  >
                                    {t("newTour.return_point")}
                                  </Typography>
                                  <Box direction="row">
                                    {" "}
                                    <Box
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            name="redirectToHomeWhileFinished"
                                            checked={
                                              props.state.formDatas
                                                .redirectToHomeWhileFinished
                                            }
                                            onChange={
                                              props.updateRedirectToHomeWhileFinished
                                            }
                                            color="primary"
                                          />
                                        }
                                        label={t("newTour.redirect_to_home")}
                                      />
                                      <InfoPopover
                                        title={t("newTour.redirect_to_title")}
                                        text={t("newTour.redirect_to_home_info")}
                                        src="/images/fin-de-partie-avec-redirect.webp"
                                      ></InfoPopover>
                                    </Box>
                                    <br />
                                  </Box>
                                  {props.state.formDatas
                                    .redirectToHomeWhileFinished && (
                                      <>
                                        <Button
                                          className={props.classes.softButton}
                                          fullWidth
                                          variant="outlined"
                                          onClick={() =>
                                            props.openMapDialog("HOME")
                                          }
                                          style={{
                                            backgroundColor: "#F8F9FA",
                                            borderRadius: "12px",
                                            border: "1px solid #E0E0E0",
                                            color: "#1F2937",
                                            padding: "12px 24px",
                                            marginBottom: 16,
                                            textTransform: "none",
                                            fontWeight: 500,
                                            transition: "all 0.2s ease-in-out",
                                            "&:hover": {
                                              backgroundColor: "#F1F5F9",
                                              borderColor: "#D1D5DB",
                                            },
                                          }}
                                        >
                                          {t("newTour.select_pos")}
                                        </Button>

                                        <Box className={props.classes.coordsRow} style={{ display: "flex", gap: 12 }}>
                                          <TextField
                                            fullWidth
                                            label={t("newTour.latitude")}
                                            variant="outlined"
                                            value={
                                              props.state.formDatas.homeCoords
                                                .latitude !== 0
                                                ? props.state.formDatas.homeCoords
                                                  .latitude
                                                : ""
                                            }
                                            onChange={
                                              props.updateHomeCoordsLatitude
                                            }
                                            className={props.classes.textField}
                                            style={{
                                              "& .MuiOutlinedInput-root": {
                                                borderRadius: "12px",
                                                backgroundColor: "#F8F9FA",
                                                "&:hover": {
                                                  backgroundColor: "#F1F5F9",
                                                },
                                              },
                                            }}
                                          />
                                          <TextField
                                            fullWidth
                                            label={t("newTour.longitude")}
                                            variant="outlined"
                                            value={
                                              props.state.formDatas.homeCoords
                                                .longitude !== 0
                                                ? props.state.formDatas.homeCoords
                                                  .longitude
                                                : ""
                                            }
                                            onChange={
                                              props.updateHomeCoordsLongitude
                                            }
                                            className={props.classes.textField}
                                            style={{
                                              "& .MuiOutlinedInput-root": {
                                                borderRadius: "12px",
                                                backgroundColor: "#F8F9FA",
                                                "&:hover": {
                                                  backgroundColor: "#F1F5F9",
                                                },
                                              },
                                            }}
                                          />
                                        </Box>
                                      </>
                                    )}
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        )}
                    </Grid>
                  </>
                )}
              </Grid>

              <Grid item xs={12}>
                <Box
                  className={props.classes.pannel}
                  style={{ marginTop: 8 }}
                >
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{
                      fontWeight: 600,
                      marginBottom: 16,
                      color: "#1F2937",
                    }}
                  >
                    {t("newTour.zones")}
                  </Typography>

                  {!props.state.formDatas.launchZonesAfterEachOther && (
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: 16,
                      }}
                    >
                      <FormControl fullWidth variant="outlined" className={props.classes.select}>
                        <InputLabel>{t("newTour.last_zone")}</InputLabel>
                        <Select
                          value={props.state.formDatas.finalZoneId || ""}
                          onChange={props.handleFinalZoneIdChanged}
                          label={t("newTour.last_zone")}
                        >
                          <MenuItem value="">
                            <em>{t("newTour.last_zone_default")}</em>
                          </MenuItem>
                          {zonesItems.map((zone) => (
                            <MenuItem
                              key={zone.idInt}
                              value={zone.idInt}
                            >
                              {zone.primary}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {!!props.state.formDatas.finalZoneId && (
                        <IconButton
                          className={props.classes.deleteIconButton}
                          onClick={props.deleteFinalZoneId}
                          style={{
                            padding: "10px",
                            color: "#EF4444",
                            backgroundColor: "#FEE2E2",
                            "&:hover": {
                              backgroundColor: "#FECACA",
                            },
                          }}
                        >
                          <Delete style={{ fontSize: 20 }} />
                        </IconButton>
                      )}
                      <InfoPopover
                        title={t("newTour.last_zone")}
                        text={t("newTour.info_last_zone_text")}
                        isWhite={false}
                      />
                    </Box>
                  )}

                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "12px",
                      backgroundColor: "#F8FAFC",
                      borderRadius: "8px",
                      border: "1px solid #E2E8F0",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            props.state.formDatas
                              .launchZonesAfterEachOther || false
                          }
                          onChange={props.updateLaunchZonesAfterEachOther}
                          color="primary"
                        />
                      }
                      label={
                        <Typography
                          style={{
                            fontSize: "14px",
                            color: "#1F2937",
                            fontWeight: 500,
                          }}
                        >
                          {t("newTour.launchZonesAfterEachOther")}
                        </Typography>
                      }
                      style={{
                        marginLeft: 0,
                      }}
                    />
                    <InfoPopover
                      title={t(
                        "newTour.launchZonesAfterEachOtherInfoTitle"
                      )}
                      text={t(
                        "newTour.launchZonesAfterEachOtherInfoText"
                      )}
                      isWhite={false}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <Box
              className={props.classes.actionBar}
              style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                padding: "16px",
                background:
                  "linear-gradient(to top, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.1) 65%, rgba(0, 0, 0, 0) 100%)",
                backdropFilter: "blur(12px)",
                WebkitMaskImage:
                  "linear-gradient(to top, black 0%, black 65%, transparent 100%)",
                maskImage:
                  "linear-gradient(to top, black 0%, black 65%, transparent 100%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                zIndex: 1000,
                boxShadow: "0 -1px 3px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Link
                className={props.classes.returnButtonLink}
                to={`/`}
                style={{ textDecoration: "none" }}
              >
                <Button
                  variant="outlined"
                  color="darkGrey"
                  style={{
                    minWidth: "120px",
                    height: "36px",
                    textTransform: "none",
                    borderRadius: "8px",
                    padding: "0 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fff",
                  }}
                >
                  {t("newZone.retour_button")}
                </Button>
              </Link>
              <Button
                variant="contained"
                color="primary"
                className={`${props.classes.saveButton} ${props.state.role === "NO_SUBSCRIBTION" ||
                  props.state.tourDisabled
                  ? props.classes.buttonDisabled
                  : ""
                  }`}
                type="submit"
                style={{
                  minWidth: "120px",
                  height: "36px",
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "0 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={props.submitForm}
              >
                {props.state.editing ? (
                  <div>{t("newZone.enregistrer_button")}</div>
                ) : (
                  <div>{t("newZone.ajouter_button")}</div>
                )}
              </Button>
            </Box>
          </form>
        </Container>

        <DialogWarning
          open={props.state.dialogWaringOpened}
          primaryText={t("newTour.delete_zone_warning")}
          secondaryText={t("newTour.delete_zone_confirm")}
          primaryAction={props.deleteZone}
          closeAction={props.closeDeleteZoneDialog}
          idItem={props.state.zoneIdToDelete}
          primaryButtonText={t("parcours_list.delete_button")}
          secondaryButtonText={t("parcours_list.cancel_button")}
        />

        <LoadingView
          className={props.classes.loadingView}
          open={props.state.loadingViewOpened}
        />

        <CustomAlert
          severity="error"
          message={props.state.errorMessage}
          duration={5000}
          onClose={props.resetErrorAlert}
          height={90}
        />

        <CustomAlert
          severity="success"
          message={props.state.successMessage}
          duration={3000}
          onClose={props.resetSuccessAlert}
          height={90}
        />

        {/* TUTO DÉSACTIVÉ - à réactiver si besoin
        {props.state.tutorialSteps?.step2 === false && (
          <TutorialBubble
            style={{ position: "absolute" }}
            message={t("tuto.step2")}
          />
        )}

        {props.state.tutorialSteps?.step5 === false &&
          props.state.tutorialSteps?.step1 === true &&
          props.state.tutorialSteps?.step2 === true &&
          props.state.tutorialSteps?.step3 === true &&
          props.state.tutorialSteps?.step4 === true && (
            <TutorialBubble
              style={{ position: "absolute" }}
              message={`${t("tuto.step5Part1")}${props.state.testCode ? props.state.testCode : ""
                }${t("tuto.step5Part2")}`}
            />
          )}
        */}

        <SelectLocationDialog
          zones={props.state.zones}
          type={props.mapType}
          lat={props.showLatOnMap}
          lng={props.showLngOnMap}
          open={props.mapDialogOpen}
          onClose={() => props.closeMapDialog()}
          coordsNE={props.state.formDatas.cameraBoundsNE}
          coordsSW={props.state.formDatas.cameraBoundsSW}
          onLocationSelected={(location, type) => {
            if (type === "SW") {
              props.setCameraBoundsSWLocation(location);
            }
            if (type === "NE") {
              props.setCameraBoundsNELocation(location);
            }
            if (type === "HOME") {
              props.setHomeLocation(location);
            }
          }}
        />
      </Box>
    </>
  );
};

export default TourView;
